import { z } from 'zod';

export const authUserSchema = z.object({
  id: z.string(),
  email: z.string(),
  displayName: z.string().nullable(),
  roles: z.array(z.string()),
  permissions: z.array(z.string()),
  /** The account's picture. Null is normal — the initial stands in for it. */
  avatarUrl: z.string().nullish(),
});

export const authResponseSchema = z.object({
  accessToken: z.string(),
  expiresAt: z.string(),
  user: authUserSchema,
});

export type AuthUser = z.infer<typeof authUserSchema>;
export type AuthResponse = z.infer<typeof authResponseSchema>;

export interface Credentials {
  email: string;
  password: string;
}

export interface RegistrationDetails extends Credentials {
  displayName?: string;
}
